module.exports = __webpack_public_path__ + "static/media/loginbg.9caaaed8.png";